import { UserManager } from 'oidc-client-ts';
import { oidcConfig } from './oidcConfig';

// Create and export a single, centralized UserManager instance.
// This instance should be used across the entire application to ensure consistency.
export const userManager = new UserManager(oidcConfig);

// Import the config to ensure we have the same values
export const getOidcStringfyToken = (): string | null => {
  // Check both sessionStorage and localStorage for the OIDC user data
  const authority = oidcConfig.authority as string;
  const clientId = oidcConfig.client_id as string;
  const key = `oidc.user:${authority}:${clientId}`;

  const userData = sessionStorage.getItem(key) || localStorage.getItem(key);

  if (!userData) {
    console.error('No OIDC user data found in storage.');
    return null;
  }

  return userData;
}

// Function to get the access token from react-oidc-context storage
export const getAccessTokenSync = (): string | null => {
  try {
    const user = JSON.parse(getOidcStringfyToken() || '{}');
    return user.access_token;
  } catch (error) {
    console.error('Failed to get OIDC access token:', error);
    return null;
  }
};

// Function to get the id_token from react-oidc-context storage
export const getIdTokenSync = (): string | null => {
  try {
    const user = JSON.parse(getOidcStringfyToken() || '{}');
    return user.id_token;
  } catch (error) {
    console.error('Failed to get OIDC id token:', error);
    return null;
  }
};

// Function to get the account_id from profile in session storage
export const getAccountIdSync = (): string | null => {
  try {
    const user = JSON.parse(getOidcStringfyToken() || '{}');
    return user?.profile?.account_id || null;
  } catch (error) {
    console.error('Failed to get account_id from profile:', error);
    return null;
  }
};

// Function to get the user email from profile in session storage
export const getUserEmailSync = (): string | null => {
  try {
    const user = JSON.parse(getOidcStringfyToken() || '{}');
    return user?.profile?.email || null;
  } catch (error) {
    console.error('Failed to get email from profile:', error);
    return null;
  }
};

// Async version for compatibility
export const getAccessToken = async (): Promise<string | null> => {
  return getAccessTokenSync();
};

// Async version for id_token
export const getIdToken = async (): Promise<string | null> => {
  return getIdTokenSync();
};

// Async version for account_id
export const getAccountId = async (): Promise<string | null> => {
  return getAccountIdSync();
};